import { render } from "./vdvcisonline.vue?vue&type=template&id=f34e49ac&scoped=true"
import script from "./vdvcisonline.vue?vue&type=script&lang=js"
export * from "./vdvcisonline.vue?vue&type=script&lang=js"

import "./vdvcisonline.vue?vue&type=style&index=0&id=f34e49ac&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34e49ac"]])

export default __exports__